// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"9c852471e9e3802e84c1","147":"d75946d24ebc7500621d","251":"de71ea65405c55c358b5","265":"88cbfd9a071139a17262","352":"f9e8f8886005fac49547"}[chunkId] + ".js";
};